import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  getUserNotifications,
  markNotificationRead,
} from '../../modules/notification';
import NotificationsPopover from './NotificationPopover';
import ForceRefreshModal from '../elements/ForceRefreshModel';

const UserNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [totalUnRead, setTotalUnRead] = useState(0);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [refreshNotification, setRefreshNotification] = useState(null);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await getUserNotifications(0, 5);
      setNotifications(response.notifications);
      setTotalUnRead(response.total_unread);
      const refreshNotif = response.notifications.find(
        (n) => n.type === 'refresh_required' && n.status === 'unread'
      );

      setRefreshNotification(refreshNotif || null);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 300000);
    return () => clearInterval(interval);
  }, []);

  const handleOpenPopover = (event) => setAnchorEl(event.currentTarget);

  const handleRefreshConfirm = async () => {
    setRefreshNotification(null);
    if (refreshNotification) {
      await markNotificationRead(refreshNotification.id);
    }
    window.location.reload();
  };
  const handleCancelConfirm = async () => {
    setRefreshNotification(null);
    if (refreshNotification) {
      await markNotificationRead(refreshNotification.id);
    }
  };
  return (
    <>
      <IconButton
        onClick={handleOpenPopover}
        aria-label="Notifications"
        disableRipple>
        <Badge badgeContent={totalUnRead} color="error">
          <NotificationsIcon
            sx={{ color: anchorEl ? 'var(--primary-color)' : 'action.active' }}
          />
        </Badge>
      </IconButton>
      <NotificationsPopover
        notifications={notifications}
        open={Boolean(anchorEl)}
        setOpen={setAnchorEl}
        totalUnRead={totalUnRead}
        loading={loading}
        fetchNotifications={fetchNotifications}
      />

      {refreshNotification && (
        <ForceRefreshModal
          open={Boolean(refreshNotification)}
          title={refreshNotification?.title}
          message={refreshNotification?.body}
          onConfirm={handleRefreshConfirm}
          onClose={handleCancelConfirm}
        />
      )}
    </>
  );
};

export default UserNotifications;
